import React, { useRef } from 'react';
import styles from './FileUpload.module.scss';
import Text from '../../../Text';

type Props = {
	value?: File | null;
	onChange?: (file: File | null) => void;
	name?: string;
	accept?: string;
	disabled?: boolean;
};

const FileUpload: React.FC<Props> = ({
	value = null,
	onChange,
	name,
	accept,
	disabled,
}) => {
	const hiddenFileInput = useRef<HTMLInputElement | null>(null);

	const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const fileUploaded = e.currentTarget.files?.[0] ?? null;
		onChange?.(fileUploaded);
	};

	const handleFilePick = () => {
		if (!disabled) hiddenFileInput.current?.click();
	};

	return (
		<div className={styles.wrapper}>
			<div
				className={styles.uploadButton}
				onClick={handleFilePick}
				aria-disabled={disabled}
			>
				{value ? (
					<div className={styles.fileName}>
						{value.name.length > 35
							? value.name.substring(0, 35).concat('...')
							: value.name}
					</div>
				) : (
					<div className={styles.placeholder}>
						<Text tx='base.shared.pickFile' />
						<i className='fa-solid fa-angle-right' aria-hidden='true'></i>
					</div>
				)}
			</div>

			<input
				ref={hiddenFileInput}
				name={name}
				type='file'
				accept={accept}
				disabled={disabled}
				onChange={handleOnChange}
				className={styles.input}
			/>
		</div>
	);
};

export default FileUpload;
